import { render, staticRenderFns } from "./mod12.vue?vue&type=template&id=1c67ae6d&scoped=true&"
import script from "./mod12.vue?vue&type=script&lang=js&"
export * from "./mod12.vue?vue&type=script&lang=js&"
import style0 from "./mod12.vue?vue&type=style&index=0&id=1c67ae6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c67ae6d",
  null
  
)

export default component.exports